import React, { useEffect, useState, useContext, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import io from 'socket.io-client'
import httpClient from 'utility/httpClient.util'
import { Alert } from 'react-bootstrap'
//import NotifyContent  from 'components/atoms/custom/global/notifyToastTemplates'
import { ToastProvider, useToasts } from 'react-toast-notifications'
import { Button, FormGroup, FormLabel, Form, Row, Col } from 'react-bootstrap'
import { WebSocketContext } from 'contexts/WebSocketProvider'
import PNotify from 'pnotify/dist/es/PNotify'
import useAuth from "hooks/useAuth";
PNotify.defaults.icons = 'fontawesome5'

let defaultContent = {
  image: 'https://via.placeholder.com/150x150',
  vn: '',
  hn: '',
  name: '',
  text: '',
}

export const AlertMessage = ({ toastId, data, removeToast = () => {} }) => {
  
  const { variant, children, title, buttonName, buttonLink } = data
  let history = useHistory()
  //console.log('p',props)
  const heading = title ? title : 'Information'
  const content = data.message ? data.message : data
  const onDismiss = () => {
    removeToast(toastId, () => {
      // console.log("ok remove", toastId);
    })
  }
  return (
    <Alert
      variant={variant}
      dismissible={false}
      onClose={onDismiss}
      className="alert-toast"
    >
      <Alert.Heading>{heading}</Alert.Heading>
      {content}
      {buttonName && (
        <React.Fragment>
          <hr />
          <div className="d-flex justify-content-end">
            <Button
              onClick={() => {
                if (buttonLink) history.push(buttonLink)

                if (onDismiss) {
                  onDismiss()
                }
              }}
              variant="primary"
            >
              {buttonName}
            </Button>
          </div>
        </React.Fragment>
      )}
    </Alert>
  )
}

const NotifyContent = ({
  title = 'การแจ้งเตือนใหม่',
  content = defaultContent,
}) => {
  return (
    <>
      <h4>{title}</h4>
      <Row>
        <Col md={4} xl={4}>
          <img width="100" height="100" src={content.image} alt="" />
        </Col>
        <Col md={8} xl={8}>
          <p>
            {content.vn && (
              <>
                VN: {content.vn} <br />
              </>
            )}
            HN: {content.hn} <br />
            {content.name} <br />
            {content.text}
          </p>
        </Col>
      </Row>
    </>
  )
}

const INIT_VALUE =
  '{"room":"room","event":"changed","data":{"sender":"System","messageType":"dataChange","destination":"notifyQueuePharmacy","message":"hello"}}'

const isSilentValue = (value) =>
  value === true || value === 'true' || value === 1 || value === '1'

//let socket = getSocketObject()
const Notification = ({
  room = null,
  event = null,
  designerData,
  designerKey,
  onCreateCallback,
  onCallDesignerEvent = () => {},
  onNotify = () => {},
  refreshEvent: onRefreshEvent,
  silent = false,
  slient = false,
}) => {
  const { config,getConfig,getJsonConfig } = useAuth();
  const notificationOptionsRef = useRef({
    onCallDesignerEvent,
    onNotify,
    onRefreshEvent,
    silent,
    slient,
  })
  const boundEventsRef = useRef({})
  const subscriberRef = useRef(Symbol('alert-subscriber'))

  notificationOptionsRef.current = {
    onCallDesignerEvent,
    onNotify,
    onRefreshEvent,
    silent,
    slient,
  }

  useEffect(() => {
    notificationOptionsRef.current = {
      onCallDesignerEvent,
      onNotify,
      onRefreshEvent,
      silent,
      slient,
    }
  }, [onCallDesignerEvent, onNotify, onRefreshEvent, silent, slient])

  const refreshCallback = () => {
    console.log('refreshCallback', designerKey, { room, event })
    triggerRefreshEvent()
  }

  const triggerRefreshEvent = (notificationEvent) => {
    const notificationOptions = notificationOptionsRef.current || {}

    if (typeof notificationOptions.onRefreshEvent === 'function') {
      try {
        notificationOptions.onRefreshEvent(notificationEvent)
      } catch (error) {
        console.warn('AlertSubscribe refreshEvent failed:', error)
      }
    }

    if (typeof notificationOptions.onCallDesignerEvent === 'function') {
      notificationOptions.onCallDesignerEvent(designerKey, 'refreshEvent', {
        room,
        event,
      })
    }
  }

  let callback = {
    refreshCallback: refreshCallback,
  }

  useEffect(() => {
    if (onCreateCallback) {
      onCreateCallback(designerKey, callback)
    }
  }, [designerData])

  const { addToast, removeToast } = useToasts()
  const {
    connected,
    currentChannel,
    socket,
    enableDebugLog,
    subscribe,
    unsubscribe,
    bindBroadcast,
    unbindBroadcast,
    broadcastMessage,
    pushMessage,
  } = useContext(WebSocketContext)
  const [msgList, setMsgList] = useState([{ room: 'test' }, { room: 'test2' }])

  const [value, setValue] = useState(INIT_VALUE)
  //const [jsonValue, setJsonValue] = useState(designerData[designerKey] || designerData || {})
  useEffect(() => {
    const subscriber = subscriberRef.current
    enableDebugLog(false)
    //console.log('context',getJsonConfig('notification_play_sound'))
    
    if (socket && room) joinChannel()
    return () => {
      if (room) {
        unsubscribe(room, subscriber) // Release only this alert subscriber
        if (boundEventsRef.current[room]) {
          boundEventsRef.current[room].clear() // Clear event bindings for the previous room
          delete boundEventsRef.current[room]
        }
      }
    }
  }, [socket, room, event])

  const notifyWarning = (data) => {
    return null
  }

  const renderContent = (toastId, data) => {
    const content = data.message ? data.message : data
    return (
      <AlertMessage
        {...data}
        onDismiss={() => {
          removeToast(toastId, () => {
            // console.log("ok remove", toastId);
          })
        }}
      >
        {content}
      </AlertMessage>
    )
  }

  const audioCache = {};
  const playAlertSound = async (appearance) => {
    const playSound = getJsonConfig("notification_play_sound");
    if (playSound) {
      // 1️⃣ Find sound source — prioritize appearance sound, fallback to default
      let sourceUrl = playSound?.[appearance]?.sourceUrl || playSound?.sourceUrl;
      if (!sourceUrl) return; // No valid source, stop early

      // 2️⃣ Determine loop count
      const loopCount = playSound?.[appearance]?.loopCount ?? playSound?.loopCount ?? 3;

      // 3️⃣ Function to play once
      const playOnce = (url) => {        
        if (!audioCache[url]) {
          audioCache[url] = new Audio(url);
        }
        const audio = audioCache[url];        
        return audio.play().catch(err => console.warn("Audio play failed:", err));
      };

      // 4️⃣ Play multiple times with delay
      for (let i = 0; i < loopCount; i++) {
        await playOnce(sourceUrl);
        await new Promise(resolve => setTimeout(resolve, 500)); // 0.5s gap
      }
    }
  };




  const joinChannel = () => {
    //Check exist channel

    const channelName = room
    const eventName = event
    if (!channelName || !eventName) return
    const boundEvents = boundEventsRef.current

    // Subscribe to the channel
    const channel = subscribe(channelName, subscriberRef.current)
    if (!boundEvents[channelName]) {
      boundEvents[channelName] = new Set() // Use a Set to track unique event bindings
    }

    // Check if the event has already been bound
    if (!boundEvents[channelName].has(eventName)) {
      channel.bind(eventName, (event) => {
        console.log('debug changed', event)
        //setEvent(event)

        

        const appearance = ["success","error","info","warning"].includes(event.data?.appearance)
          ? event.data.appearance
          : "info";
        const notificationOptions = notificationOptionsRef.current || {}

        try {
          notificationOptions.onNotify(event)
        } catch (error) {
          console.warn('AlertSubscribe onNotify failed:', error)
        }

        if (
          !isSilentValue(notificationOptions.silent) &&
          !isSilentValue(notificationOptions.slient)
        ) {
          playAlertSound(appearance)
          const toastId = new Date().getTime()
          addToast(
            <AlertMessage
              toastId={toastId}
              data={event.data}
              removeToast={removeToast}
            />,
            {
              id: toastId,
              appearance: appearance,
              autoDismiss: false,
              onDismiss: () => {
                console.log('onDis')
              },
            }
          )
        }
        triggerRefreshEvent(event)
      })
      boundEvents[channelName].add(eventName)
    } else {
      console.log(
        `Event '${eventName}' is already bound to channel '${channelName}'`
      )
    }
  }

  return <div></div>
}

const AlertSubscribe = (props) => {
  let { designerData, designerKey } = props;

  // เตรียม props เฉพาะจาก designerData
  const designerProps = designerKey ? designerData?.[designerKey] || {} : designerData || {};

  // กำหนด room ที่จะส่งไป Notification โดย fallback ไปที่ defaultRoom หาก room เป็น null หรือ undefined
  const effectiveRoom =
    props.room ?? designerProps.room ?? props.defaultRoom ?? designerProps.defaultRoom;
  const effectiveEvent = props.event ?? designerProps.event;

  return (
    <ToastProvider
      placement="bottom-right"
      newestOnTop={true}
      _components={{ Toast: AlertMessage }}
    >
      <Notification
        {...designerProps}
        {...props}
        room={effectiveRoom} // แทนค่า room หลัง fallback
        event={effectiveEvent}
      />
    </ToastProvider>
  );
};


AlertSubscribe.defaultProps = {
  defaultRoom: null,
  designerData: {
    defaultRoom:null,
    room: null,
    event: null,
    refreshCallback: () => {},
    refreshEvent: () => {},
  },
  event: null,
  onCallDesignerEvent: () => {},
  onNotify: () => {},
  refreshEvent: null,
  room: null,
  silent: false,
}

export default AlertSubscribe
